<template>
  <v-app light class="public-payment-app">
    <main class="public-payment-shell">
      <div class="public-payment-background"></div>

      <v-container fill-height class="public-payment-container">
        <v-layout align-center justify-center>
          <v-flex xs12 sm10 md8 lg6>
            <div class="public-payment-card">
              <div class="public-payment-brand">
                <img src="static/logo.png" alt="Savoy" class="public-payment-logo">
                <div class="public-payment-brand-copy">
                  <span class="public-payment-eyebrow">Savoy Controle</span>
                  <h1>{{ pageHeading }}</h1>
                  <p>{{ pageSubheading }}</p>
                </div>
              </div>

              <div v-if="status === 'loading'" class="public-payment-state">
                <div class="public-payment-icon public-payment-icon-loading">
                  <v-progress-circular
                    indeterminate
                    :size="68"
                    :width="5"
                    color="secondary"
                  ></v-progress-circular>
                </div>
                <h2>{{ loadingTitle }}</h2>
                <p>{{ loadingMessage }}</p>
              </div>

              <div v-else-if="status === 'success'" class="public-payment-state">
                <div class="public-payment-icon public-payment-icon-success">
                  <v-icon large color="white">check_circle</v-icon>
                </div>
                <h2>{{ responseTitle }}</h2>
                <p>{{ responseMessage }}</p>

                <div v-if="hasPagamentoDetails" class="public-payment-details">
                  <div class="public-payment-detail">
                    <span>Pagamento</span>
                    <strong>#{{ pagamento.id }}</strong>
                  </div>
                  <div class="public-payment-detail">
                    <span>Status</span>
                    <strong>{{ pagamento.status || '---' }}</strong>
                  </div>
                  <div class="public-payment-detail" v-if="pagamento.descricao">
                    <span>Descrição</span>
                    <strong>{{ pagamento.descricao }}</strong>
                  </div>
                  <div class="public-payment-detail" v-if="pagamento.imovel">
                    <span>Imóvel</span>
                    <strong>{{ pagamento.imovel }}</strong>
                  </div>
                  <div class="public-payment-detail" v-if="pagamento.solicitante">
                    <span>Solicitante</span>
                    <strong>{{ pagamento.solicitante }}</strong>
                  </div>
                </div>
              </div>

              <div v-else class="public-payment-state">
                <div class="public-payment-icon public-payment-icon-error">
                  <v-icon large color="white">highlight_off</v-icon>
                </div>
                <h2>{{ responseTitle }}</h2>
                <p>{{ responseMessage }}</p>
              </div>

              <div class="public-payment-footer">
                <span>Ação: {{ actionLabel }}</span>
                <span v-if="token">Token {{ maskedToken }}</span>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </main>
  </v-app>
</template>

<script>
import axios from 'axios'
import { apiURL } from '@/config'

export default {
  data () {
    return {
      status: 'loading',
      responseTitle: '',
      responseMessage: '',
      pagamento: null
    }
  },
  computed: {
    token () {
      return this.$route.params.token || ''
    },
    actionType () {
      return this.$route.meta.paymentAction || 'aprovar'
    },
    isApproveAction () {
      return this.actionType === 'aprovar'
    },
    actionLabel () {
      return this.isApproveAction ? 'Aprovação de pagamento' : 'Rejeição de pagamento'
    },
    pageHeading () {
      return this.isApproveAction ? 'Confirmando aprovação' : 'Confirmando rejeição'
    },
    pageSubheading () {
      return this.isApproveAction
        ? 'Estamos registrando a autorização enviada pelo WhatsApp.'
        : 'Estamos registrando a rejeição enviada pelo WhatsApp.'
    },
    loadingTitle () {
      return this.isApproveAction ? 'Aprovando pagamento' : 'Rejeitando pagamento'
    },
    loadingMessage () {
      return 'Aguarde enquanto validamos este link e concluímos a ação.'
    },
    hasPagamentoDetails () {
      return !!(this.pagamento && (this.pagamento.id || this.pagamento.status || this.pagamento.descricao || this.pagamento.imovel || this.pagamento.solicitante))
    },
    maskedToken () {
      if (this.token.length <= 10) return this.token
      return this.token.slice(0, 6) + '...' + this.token.slice(-4)
    }
  },
  watch: {
    '$route' () {
      this.executeAction()
    }
  },
  mounted () {
    this.executeAction()
  },
  methods: {
    executeAction () {
      if (!this.token) {
        this.setError({
          title: 'Link inválido',
          message: 'O token de avaliação não foi informado.'
        })
        return
      }

      this.status = 'loading'

      axios.get(this.buildEndpoint()).then((response) => {
        const payload = response && response.data ? response.data : {}

        if (payload.success === false) {
          this.setError(payload)
          return
        }

        this.status = 'success'
        this.responseTitle = payload.title || 'Avaliação registrada'
        this.responseMessage = payload.message || this.defaultSuccessMessage()
        this.pagamento = this.normalizePagamento(payload.pagamento)
      }).catch((error) => {
        const payload = error && error.response && error.response.data ? error.response.data : {}
        this.setError(payload)
      })
    },
    buildEndpoint () {
      return `${apiURL}/public/pagamentos/${this.actionType}/${encodeURIComponent(this.token)}`
    },
    defaultSuccessMessage () {
      return this.isApproveAction
        ? 'O pagamento foi aprovado com sucesso.'
        : 'O pagamento foi rejeitado com sucesso.'
    },
    normalizePagamento (pagamento) {
      if (!pagamento) return null

      return {
        id: pagamento.id,
        status: pagamento.status,
        descricao: pagamento.descricao,
        imovel: pagamento.imovel,
        solicitante: typeof pagamento.solicitante === 'object' && pagamento.solicitante !== null
          ? pagamento.solicitante.name
          : pagamento.solicitante
      }
    },
    setError (payload) {
      this.status = 'error'
      this.pagamento = this.normalizePagamento(payload.pagamento)
      this.responseTitle = payload.title || 'Não foi possível concluir a avaliação'
      this.responseMessage = payload.message || payload.error || 'Esse link é inválido, expirou ou esta avaliação já foi processada.'
    }
  }
}
</script>

<style scoped>
.public-payment-app {
  background:
    radial-gradient(circle at top right, rgba(243, 112, 33, 0.18), transparent 28%),
    linear-gradient(160deg, #f4f7fb 0%, #eef2f7 45%, #ffffff 100%);
}

.public-payment-shell {
  min-height: 100vh;
  position: relative;
  overflow: hidden;
}

.public-payment-background {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background:
    linear-gradient(125deg, rgba(46, 49, 146, 0.92), rgba(46, 49, 146, 0.74)),
    linear-gradient(180deg, transparent, rgba(255, 255, 255, 0.15));
  clip-path: polygon(0 0, 100% 0, 100% 58%, 0 78%);
}

.public-payment-container {
  position: relative;
  z-index: 1;
}

.public-payment-card {
  position: relative;
  overflow: hidden;
  padding: 34px;
  border-radius: 28px;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 28px 70px rgba(26, 36, 74, 0.18);
}

.public-payment-card:before {
  content: '';
  position: absolute;
  top: -60px;
  right: -60px;
  width: 180px;
  height: 180px;
  border-radius: 100%;
  background: rgba(243, 112, 33, 0.11);
}

.public-payment-brand {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  margin-bottom: 28px;
}

.public-payment-logo {
  width: 148px;
  max-width: 32%;
  display: block;
  margin-right: 18px;
}

.public-payment-brand-copy {
  flex: 1;
}

.public-payment-eyebrow {
  display: inline-block;
  margin-bottom: 8px;
  color: #f37021;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.18em;
  text-transform: uppercase;
}

.public-payment-brand-copy h1 {
  margin: 0 0 8px;
  color: #1d2550;
  font-size: 28px;
  line-height: 1.12;
  font-weight: 700;
}

.public-payment-brand-copy p {
  margin: 0;
  color: #5a6387;
  font-size: 15px;
  line-height: 1.55;
}

.public-payment-state {
  position: relative;
  z-index: 1;
}

.public-payment-icon {
  width: 78px;
  height: 78px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 24px;
  margin-bottom: 20px;
  box-shadow: 0 18px 40px rgba(46, 49, 146, 0.15);
}

.public-payment-icon-success {
  background: linear-gradient(135deg, #2e3192, #4b66d3);
}

.public-payment-icon-error {
  background: linear-gradient(135deg, #d94841, #f37021);
}

.public-payment-icon-loading {
  background: rgba(243, 112, 33, 0.1);
  box-shadow: none;
}

.public-payment-state h2 {
  margin: 0 0 10px;
  color: #1d2550;
  font-size: 26px;
  line-height: 1.15;
  font-weight: 700;
}

.public-payment-state p {
  margin: 0;
  color: #5c6380;
  font-size: 16px;
  line-height: 1.7;
}

.public-payment-details {
  margin-top: 26px;
  padding: 18px;
  border: 1px solid rgba(46, 49, 146, 0.08);
  border-radius: 20px;
  background: linear-gradient(180deg, rgba(244, 247, 251, 0.9), rgba(255, 255, 255, 0.98));
}

.public-payment-detail {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid rgba(46, 49, 146, 0.08);
}

.public-payment-detail:last-child {
  border-bottom: 0;
  padding-bottom: 0;
}

.public-payment-detail:first-child {
  padding-top: 0;
}

.public-payment-detail span {
  color: #7c839f;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.public-payment-detail strong {
  color: #1d2550;
  font-size: 15px;
  text-align: right;
}

.public-payment-footer {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  margin-top: 26px;
  padding-top: 18px;
  border-top: 1px solid rgba(46, 49, 146, 0.08);
  color: #8b93af;
  font-size: 12px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

@media (max-width: 959px) {
  .public-payment-card {
    padding: 28px 24px;
    border-radius: 24px;
  }

  .public-payment-brand {
    display: block;
  }

  .public-payment-logo {
    max-width: 170px;
    width: 48%;
    margin-right: 0;
    margin-bottom: 18px;
  }
}

@media (max-width: 599px) {
  .public-payment-background {
    clip-path: polygon(0 0, 100% 0, 100% 44%, 0 62%);
  }

  .public-payment-card {
    padding: 24px 18px;
    border-radius: 22px;
  }

  .public-payment-brand-copy h1,
  .public-payment-state h2 {
    font-size: 22px;
  }

  .public-payment-brand-copy p,
  .public-payment-state p {
    font-size: 14px;
  }

  .public-payment-detail {
    display: block;
  }

  .public-payment-detail strong {
    display: block;
    margin-top: 4px;
    text-align: left;
  }

  .public-payment-footer {
    display: block;
  }

  .public-payment-footer span {
    display: block;
  }

  .public-payment-footer span + span {
    margin-top: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// PublicPagamentoAvaliacao.vue?cd41ab2c